import React, { useContext } from 'react';
import { MeetingUtilsContextState, PopulatedMeeting } from './interfaces';

export const createPopulatedMeetingContext = () => React.createContext<MeetingUtilsContextState | undefined>(undefined);

export const MeetingUtilsContext = createPopulatedMeetingContext();

// raiseIfUndefined=false in case you know what you are doing and want to use the
// context in an optional way, for example a component that can be used both inside and outside of a meeting context
export function useMeetingUtilsContext(options?: { raiseIfUndefined?: true }): MeetingUtilsContextState;
export function useMeetingUtilsContext(options: { raiseIfUndefined: false }): MeetingUtilsContextState | undefined;
export function useMeetingUtilsContext(options: { raiseIfUndefined?: boolean } = {}): MeetingUtilsContextState | undefined {
    const { raiseIfUndefined = true } = options;
    const context = useContext(MeetingUtilsContext);
    if (!context && raiseIfUndefined) {
        throw new Error("useMeetingUtilsContext must be used within an MeetingUtilsContextState");
    }
    return context;
}

